export const HANDLE_ACTOR_SELECTED = 'HANDLE_ACTOR_SELECTED';
export const HANDLE_ACTOR_POSITIONED = 'HANDLE_ACTOR_POSITIONED';
export const RESET_ACTOR_POSITIONS = 'RESET_ACTOR_POSITIONS';
